import { useTranslation } from 'react-i18next';
import { useWindowTitleWithBlur } from './useWindowTitle';

export function useTranslationKeyForWindowTitle(key: string, fallbackText?: string): void {
  const { t } = useTranslation();

  const title = t(key);
  const fallbackTitle = fallbackText ?? 'Hotjar';
  const actualTitle = title && !title.includes('missing translation') ? title : fallbackTitle;

  useWindowTitleWithBlur(actualTitle, actualTitle);
}
